export default __webpack_public_path__ + "static/media/whyjust3.553e98af.svg";